import api from '../axios';

export const postLogin = async (data) =>
{
  try {
    const response = await api.post('/auth/login', data);
    return response.data;
  } catch (error) {
    console.error('Login error:', error.response?.data || error.message);
    return null;
  }
};

export const get_sessions = async () =>
{
  try {
    const response = await api.get('/auth/sessions');
    return response.data;
  } catch (error) {
    console.error('Error fetching sessions:', error);
    return null;
  }
};

export const revoke_session = async (id) =>
{
  try {
    const response = await api.delete(`/auth/sessions/${ id }`);
    return response.data;
  } catch (error) {
    console.error('Error revoking session:', error);
    return null;
  }
};

export const revoke_others = async () =>
{
  try {
    const response = await api.delete('/auth/sessions/others');
    return response.data;
  } catch (error) {
    console.error('Error revoking other sessions:', error);
    return null;
  }
};

// --- CRON CONFIGURATION API ---

export const get_cron_config = async (jobName) =>
{
  try {
    const response = await api.get(`/auth/cron/${ jobName }`);
    return response.data;
  } catch (error) {
    console.error('Error fetching cron config:', error);
    return null;
  }
};

export const update_cron_config = async (jobName, data) =>
{
  try {
    const response = await api.post(`/auth/cron/${ jobName }`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating cron config:', error);
    return null;
  }
};
